enum TrafficSignalSubType {
    GettingTraction = "GettingTraction",
    LosingTraction = "LosingTraction",
    Engagement = "Engagement",
    NewMarkets = "NewMarkets",
}

export default TrafficSignalSubType;
